<template>
  <div :class="`left-menu ${isCollapse?'left-menu--collapse' :''}`">
    <div class="logo" @click="$router.push('/')">
        <img :src="isCollapse?require('@/assets/logo_short.png'):require('@/assets/logo.png')" />
    </div>
    <el-menu
      ref="leftMenu"
      :collapse-transition="false"
      :collapse="isCollapse"
      @select="handleSelectMenu"
      :default-active='defaultActive'>
      <template v-for="item in leftMenuList">
        <el-submenu :index="item.id" v-if="item.children && item.children[0]"  :key="item.id+item.menuName" class="test">
            <template slot="title">
               <i :class="item.icon + ' iconfont'"></i>
               <span slot="title">{{item.menuName}}</span>
            </template>
            <template v-for="i in item.children" >
                <el-submenu :index="i.id" v-if="i.children && i.children[0]" :key="i.id+i.menuName"  class="test">
                    <template slot="title">{{i.menuName}} </template>
                    <el-menu-item :index="j.url || j.id" v-for="j in i.children" :key="j.id+j.menuName">{{j.menuName}}</el-menu-item>
                </el-submenu>
                <el-menu-item v-else :index="i.url || i.id" :key="i.id+i.menuName">{{i.menuName}}</el-menu-item>
            </template>
        </el-submenu>
        <el-menu-item v-else :index="item.url || item.id"  :key="item.id+item.menuName">
          <i :class="item.icon + ' iconfont'"></i>
          <span slot="title">{{item.menuName}}</span>
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'leftMenu',
  data () {
    return {
    };
  },
  props: {
    isCollapse: Boolean,
  },
  methods: {
    // 选中的导航
    handleSelectMenu (nav) {
      this.$router.push(nav);
    },
    handleShortcutClick (item) {
      this.$router.push(item.url);
    },
  },

  computed: {
    ...mapGetters([
      'menuTree',
      'menuIdMap',
      'menuUrlMap',
    ]),
    defaultActive () {
      let matchedMenuList = this.menuUrlMap[this.$route.path] || [];
      matchedMenuList = matchedMenuList.sort((a, b) => a.type >= b.type);
      let breadcrumbList = [];
      let currentMenu = matchedMenuList[0];
      if (currentMenu && this.leftMenuTreeMap) {
        breadcrumbList.unshift(currentMenu);
        let getParent = menuItem => {
          let parent = this.menuIdMap[menuItem.parentId];
          if (parent) {
            breadcrumbList.unshift(parent);
            if (parent.parentId) {
              getParent(parent);
            }
          }
        };
        getParent(currentMenu);
        for (let index = breadcrumbList.length - 1; index >= 0; index--) {
          const menu = breadcrumbList[index];
          if (this.leftMenuTreeMap.get(menu.url)) {
            return menu.url;
          }
        }
      }
      return this.$route.path;
    },
    leftMenuTreeMap () {
      // 缓存当前左侧菜单map
      let leftMenuTreeMap = new Map();
      let cacheMenuTree = (menuList) => {
        menuList.forEach(t => {
          if (t.children) {
            cacheMenuTree(t.children);
          } else if (t.url) {
            leftMenuTreeMap.set(t.url, true);
          }
        });
      };
      cacheMenuTree(this.leftMenuList);
      return leftMenuTreeMap;
    },
    leftMenuList () {
      // let withoutAuth = 'auth' in meta && !meta.auth;
      let currentModule = this.menuUrlMap[this.$route.path];
      if (currentModule && currentModule[0]) {
        return this.menuTree.find(t => t.sysFlag.toUpperCase() === currentModule[0].sysFlag.toUpperCase()).children;
      } else {
        return this.menuTree.find(t => t.sysFlag.toUpperCase() === 'SAAS')?.children;
      }
    },
  },
};
</script>

<style lang='scss'>
  .left-menu,.el-menu--popup{
    .el-submenu .el-submenu__title,.el-menu-item {
      height: 46px!important;
      line-height: 46px!important;
    }
    .el-submenu__title,.el-menu-item {
      color:hsla(0,0%,100%,.65);

      &:focus {
        background-color: #1890ff;
        color: white;
        i{
          color: white;
        }
      }

      &:hover{
        background-color: transparent;
        color: white;
        i{
          color: white;
        }
      }
    }

    .el-submenu.is-active .el-submenu__title {
      background-color: transparent;
      color: white;
      i{
        color: white;
      }
    }

    .el-menu-item.is-active{
      background-color: #1890ff;
      color: white;
      i{
        color: white;
      }
    }
  }

  .el-menu--vertical .el-menu{
    background-color: #001529;
  }

  .left-menu {
    background-color: #001529;
    height: 100%;
    width: 220px;
    display: flex;
    flex-direction: column;
    .el-menu {
      flex: 1;
      overflow: auto;
      background-color: transparent;
      border-color: transparent;
      color: white;

      i[class~=iconfont] {
        margin-right: 5px;
        vertical-align: middle;
        width: 24px;
        text-align: center;
        display: inline-block;
      }
    }

    .logo {
      line-height: 50px;
      height: 50px;
      font-size: 0;
      vertical-align: middle;
      padding-left: 20px;

      img {
        height: 40px;
        vertical-align: middle;
      }
    }

    .shortcut_menu {
      line-height: 50px;
      height: 50px;
      padding-left:20px ;
      font-size: 14px;
      vertical-align: middle;
      border-bottom: 1px solid rgba(255,255,255,0.2);
      color:hsla(0,0%,100%,.65);
      &:hover {
        color: white;
      }

      i[class^=el-icon] {
        margin-right: 5px;
        vertical-align: middle;
        width: 24px;
        text-align: center;
        font-size: 18px;
      }
    }

    .menu_action {
      color: white;
      font-size: 18px;
      height: 50px;
      line-height: 50px;
      vertical-align: middle;
      padding-left: 20px;
    }

    &.left-menu--collapse {
      width: auto;
      .logo {
        text-align: center;
        padding-left: 0px;
      }

      .shortcut_menu {

        i[class^=el-icon] {
          margin: 0;
        }
        span {
          height: 0;
          width: 0;
          overflow: hidden;
          visibility: hidden;
          display: inline-block;
        }
      }
    }
  }

  .shortcut-list-popover{
    width: 154px;
    background-color: #001529;
    color:hsla(0,0%,100%,.65);

    ul.shortcut-list {
      max-height: 352px;
      width: 100%;
      font-size: 14px;
      overflow: auto;

      li {
        line-height: 38px;
        height: 38px;
        vertical-align: middle;
        cursor: pointer;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        &:hover {
          // background-color: #ecf5ff;
          color: white;
        }
      }
    }

    &.el-popper .popper__arrow::after{
      border-right-color: #001529;
    }
  }

</style>
